var MENU_ITEM_SIZE = {
  LARGE: 'large',
  REGULAR: 'regular',
  SMALL: 'small',
  TOUCH: 'touch'
};
var DEFAULT_VARIANT = 'secondary';

export { DEFAULT_VARIANT, MENU_ITEM_SIZE };
//# sourceMappingURL=Menu.constants.js.map
